export const get: any = (url: string, auth = true, headers: HeadersInit = {}) => {
    const init: RequestInit = {
        method: 'GET',
        headers: new Headers(headers),
    };
    if (auth) {
        init.mode = 'cors';
        init.credentials = 'include';
    }

    return fetch(url, init)
        .then((res) => handleErrors(res))
        .then((res) => Promise.resolve(res.json()))
        .catch((err) => {
            return Promise.reject(err);
        });
};

export const post: any = (url: string, json: Record<string, unknown>, headers: HeadersInit = {}) => {
    const h = {
        ...headers,
        'Content-Type': 'application/json',
    };
    const init: RequestInit = {
        method: 'POST',
        headers: new Headers(h),
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify(json),
    };

    return fetch(url, init)
        .then((res) => handleErrors(res, json))
        .then((res) => Promise.resolve(res.json()))
        .catch((err) => {
            return Promise.reject(err);
        });
};

export const patch: any = (url: string, json: Record<string, unknown>) => {
    const h = {
        'Content-Type': 'application/json',
    };
    const init: RequestInit = {
        method: 'PATCH',
        headers: new Headers(h),
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify(json),
    };

    return fetch(url, init)
        .then((res) => handleErrors(res, json))
        .then((res) => Promise.resolve(res.json()))
        .catch((err) => {
            return Promise.reject(err);
        });
};

// the term "delete" is reserved word
export const deleteReq: any = (url: string, json: Record<string, unknown>) => {
    const init: RequestInit = {
        method: 'DELETE',
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify(json),
    };

    return fetch(url, init)
        .then((res) => handleErrors(res, json))
        .then((res) => Promise.resolve(res.json()))
        .catch((err) => {
            return Promise.reject(err);
        });
};

const handleErrors = async (res: Response, req: Record<string, unknown> = {}) => {
    if (!res.ok) {
        const r = await res.json();
        const msg = 'errors' in r ? r['errors'][0] : '';
        console.error(`apiError. msg: ${msg}. url: ${res.url}`, {
            url: res.url,
            req: JSON.stringify(req),
            status: res.status,
            res: JSON.stringify(r),
        });

        throw Error(msg);
    }
    return res;
};
